import * as constants from '../constants';

const mutations = {
  [constants.CHECKOUT_CART]: (state, cart) => {
    state.cart = cart;
  },
  [constants.CHECKOUT_CART_LOADING]: (state, isCartLoading) => {
    state.isCartLoading = isCartLoading;
  },
  [constants.CHECKOUT_TOTALS]: (state, totals) => {
    state.totals = totals;
  },
  [constants.CHECKOUT_TOTALS_LOADING]: (state, isTotalsLoading) => {
    state.isTotalsLoading = isTotalsLoading;
  },
  [constants.CHECKOUT_SHIPPING_METHODS]: (state, shippingMethods) => {
    state.shippingMethods = shippingMethods;
  },
  [constants.CHECKOUT_SHIPPING_ADDRESS]: (state, shippingAddress) => {
    state.shippingAddress = shippingAddress;
  },
  [constants.CHECKOUT_PAYMENT_METHODS]: (state, paymentMethods) => {
    state.paymentMethods = paymentMethods;
  },
};

export default mutations;
